import { useQuery } from '@tanstack/react-query';

import { getApprovalRequest } from '~/services/LuxLoyaltyService';

import { claimsQueryKeys } from './claimsQueryKeys';

export function useGetApprovalRequest(requestId: string | null) {
  return useQuery({
    queryKey: [...claimsQueryKeys.all, 'approval-request', requestId],
    queryFn: ({ signal }) => getApprovalRequest(requestId!, { signal }),
    select: (data) => data.result,
    enabled: !!requestId,
  });
}
